<template>
  <popup-modal
    :title="title"
    center
    @close="close"
  >
    <div class="popup-confirm-slot">
      <slot />
    </div>

    <div class="popup-confirm-buttons">
      <former-button
        :disabled="disabled || loading"
        class="popup-confirm-button"
        color="gray"
        size="small"
        @click="close"
      >
        {{ cancelButtonLabel }}
      </former-button>

      <former-button
        :disabled="disabled"
        :loading="loading"
        class="popup-confirm-button"
        :color="color"
        size="small"
        @click="confirm"
      >
        {{ confirmButtonLabel }}
      </former-button>
    </div>
  </popup-modal>
</template>

<script>
  import FormerButton from '@/components/Former/Button.vue';
  import PopupModal from '@/components/Popup/Modal.vue';

  export default {
    name: 'PopupConfirm',
    components: {
      FormerButton,
      PopupModal,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String,
        default: 'green',
      },
      confirmButtonLabel: {
        type: String,
        default: 'Confirmar',
      },
      cancelButtonLabel: {
        type: String,
        default: 'Cancelar',
      },
    },
    methods: {
      confirm() {
        this.$emit('confirm');
      },
      close() {
        if (this.loading) {
          return;
        }

        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss">
  .popup-confirm {
    .popup-content {
      top: 50%;
    }
  }
</style>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .popup-confirm-slot {
    padding: 0 $gutter;

    @media all and (min-width: $breakpoint-desktop) {
      padding-left: $gutter-bigger;
      padding-right: $gutter-bigger;
    }
  }

  .popup-confirm-buttons {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    padding: $gutter;

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter-big;
    }
  }

  .popup-confirm-button {
    & + & {
      margin: 0 0 0 $gutter-smaller;
    }
  }
</style>
